import NotificationComponent from '../Components/Notification/NotificationComponent'

function NotificationPage() {
    return (
        <NotificationComponent/>
    )
}

export default NotificationPage